"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _debounce = _interopRequireDefault(require("lodash/debounce"));

var _flatten = _interopRequireDefault(require("lodash/flatten"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _isFunction = _interopRequireDefault(require("lodash/isFunction"));

var _history = require("history");

var _authentication_alias = _interopRequireDefault(require("authentication_alias"));

var _goToHelper = require("@eig-builder/core-utils/helpers/go-to-helper");

var _reactRouterDom = require("react-router-dom");

var _privateRoute = _interopRequireDefault(require("./private-route"));

var _publicRoute = _interopRequireDefault(require("./public-route"));

var _ecommerceEventHelper = require("@eig-builder/core-utils/analytics/helpers/ecommerce-event-helper");

var _constants = require("./../store/constants");

var _AnalyticsContext = _interopRequireDefault(require("../contexts/AnalyticsContext"));

/**
 * Base router, this will transform the routes props to a react element. it will only enable one route at the same time
 *
 * @class BaseRouter
 * @extends {React.Component}
 * @param {string} defaultRoute - go to this route, when none are matched
 * @param {func} onLocationChange - can be used for analytics (page view)
 * @param {object} analytics - ref to analytics service (router will call analytics.trackPageView)
 * @param {any} store - redux store, allowing us to set the active path in the redux store, package: 'react-router-redux'
 * @param {component} appWrapper - component, all views will be wrapped inside this component
 * @param {array} routes - array with all active routes
 */
var BaseRouter =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(BaseRouter, _Component);

  function BaseRouter(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, BaseRouter);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(BaseRouter).call(this, props));
    _this.reRenderScreen = (0, _debounce["default"])(function (event) {
      if (_this.innerWidth !== window.innerWidth) {
        _this.innerWidth = window.innerWidth;

        _this.forceUpdate();
      }
    }, 150);

    if (props.inMemoryHistory) {
      // use inmemory history
      _this.history = (0, _history.createMemoryHistory)(_this.props); // push initial state

      _this.history.push(window.location.pathname);
    } else {
      _this.history = (0, _history.createBrowserHistory)(_this.props);
    }

    _this.history.listen(function (location, direction) {
      if (props.onLocationChange) {
        props.onLocationChange(location);
      }

      if (props.analytics && props.analytics.trackPageView) {
        props.analytics.trackPageView(location.pathname);
      }

      props.store.dispatch({
        type: _constants.LOCATION_CHANGE,
        payload: location
      });
      (0, _ecommerceEventHelper.TrackAnEcomEventWhenTheUrlContainsAnSuccessOrderId)(location.href, props.analytics);

      if (direction !== 'REPLACE') {
        window.scrollTo(0, 0);
      }

      if (direction === 'POP') {
        _this.forceUpdate();
      }
    }); // track pageview on first page


    if (props.analytics && props.analytics.trackPageView) {
      props.analytics.trackPageView(window.location.pathname);
    }

    (0, _ecommerceEventHelper.TrackAnEcomEventWhenTheUrlContainsAnSuccessOrderId)(window.location.href, props.analytics);
    return _this;
  }

  (0, _createClass2["default"])(BaseRouter, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.innerWidth = window.innerWidth;
      window.addEventListener('resize', this.reRenderScreen);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.reRenderScreen);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var AppWrapper = this.props.appWrapper;
      var analytics = this.props.analytics;
      return _react["default"].createElement(_AnalyticsContext["default"].Provider, {
        value: {
          analyticsService: analytics
        }
      }, _react["default"].createElement("main", {
        className: "viewport"
      }, _react["default"].createElement(_reactRouterDom.Router, {
        history: this.history
      }, _react["default"].createElement(AppWrapper, this.props.appWrapperProps, _react["default"].createElement(_reactRouterDom.Switch, null, // we get back a function of routes that gives back an object with arays
      // (to wait for a API call for example || Checkout)
      // or we ge back a array with routes
      (0, _flatten["default"])(this.props.routes.map(function (route, index) {
        if (typeof route === 'function') {
          return route();
        } else {
          return route;
        }
      })).map(function (route, index) {
        // Make sure that the analytics tags are set, otherwise throw an error
        if (!process.env.isProd) {
          if ((0, _isEmpty["default"])(route.pageType) || (0, _isEmpty["default"])(route.flowType) && !(0, _isFunction["default"])(route.flowType)) {
            console.error('!!! MUST FIX !!! is missing flowType of pageType, we need this for analaytics\n!!! MUST FIX !!! we need this because we have more then 1 onboarding flow now\n!!! MUST FIX !!! find help here: https://confluence.endurance.com/display/EWB/Analytics+Tracking', route.path || route.pattern);
          }
        }

        if (route.pattern && !route.path) {
          console.warn('Routes: Use path instead of pattern, pattern wont be supported in a next version');
        }

        if (route.isPublic) {
          return _react["default"].createElement(_publicRoute["default"], {
            key: index,
            path: route.path || route.pattern,
            component: route.component,
            exactly: route.exactly
          }) // Use path instead of pattern, pattern won't be supported in a next version
          ;
        } // normal behaviour


        if (!_this2.props.roleRoutesRequired) {
          return _react["default"].createElement(_privateRoute["default"], (0, _extends2["default"])({
            key: index,
            path: route.path || route.pattern // Use path instead of pattern, pattern won't be supported in a next version
            ,
            component: route.component,
            exactly: route.exactly
          }, route)); // We want route role management.
        } else if (_this2.props.roleRoutesRequired && (Number.isInteger(route.requiredRole) || Array.isArray(route.requiredRole))) {
          var rollsAssignedToUser = _authentication_alias["default"].rollsAssignedToUser;
          var requiredRoles = Array.isArray(route.requiredRole) ? route.requiredRole : [route.requiredRole];
          var allowed = rollsAssignedToUser && requiredRoles.some(function (r) {
            return rollsAssignedToUser.includes(r);
          });

          if (allowed) {
            return _react["default"].createElement(_privateRoute["default"], (0, _extends2["default"])({
              key: index,
              path: route.path || route.pattern // Use path instead of pattern, pattern won't be supported in a next version
              ,
              component: route.component,
              exactly: route.exactly
            }, route));
          }
        }
      }), _react["default"].createElement(_reactRouterDom.Route, {
        render: function render() {
          var path = "".concat(_this2.props.defaultRoute).concat(window.location.search).concat(window.location.hash);
          (0, _goToHelper.goToWithHistory)(_this2.history, path, true);
          return null;
        }
      }))))));
    }
  }]);
  return BaseRouter;
}(_react.Component);

BaseRouter.propTypes = {
  defaultRoute: _propTypes["default"].string.isRequired,
  onLocationChange: _propTypes["default"].func,
  basename: _propTypes["default"].string,
  analytics: _propTypes["default"].object,
  store: _propTypes["default"].any,
  appWrapper: _propTypes["default"].any,
  appWrapperProps: _propTypes["default"].object,
  routes: _propTypes["default"].array,
  inMemoryHistory: _propTypes["default"].bool,
  roleRoutesRequired: _propTypes["default"].bool
};
var _default = BaseRouter;
exports["default"] = _default;